
import { createEvent, restore } from "effector"
//export var CustomUserAgent: string = getCustomUserAgent(true)

export const CoordinateDecPoints: number = 10000

export const MainURL = "https://izba.kras-abs.ru"

export const LocalStorageKeyCustomUseAgent = "custom_user_agent"
export const LocalStorageKeyUUID = "uuid"
export const LocalStorageKeySESSION = "session"

export const pathPrefix: string = ""
export const pathMain: string = pathPrefix + "/"
export const pathLogin: string = pathPrefix + "/login"
export const pathNews: string = pathPrefix + "/news"
export const pathReconciliationActs: string = pathPrefix + "/acts"


export const pathDemand: string = pathPrefix + "/order"
export const pathDemandSubPay: string = pathDemand + "/pay"
export const pathDemandSubFree: string = pathDemand + "/free"
export const urlDemandSubGroupServices: string = pathDemand + "/services"
export const pathDemandSubGroupServices: string = urlDemandSubGroupServices + "/:groupId"

export const pathSchedule: string = pathPrefix + "/schedule"
export const pathContacts: string = pathPrefix + "/contacts"
export const pathAddAccount: string = pathPrefix + "/addAccount"
export const pathAddAccountOnLogin: string = pathPrefix + "/newAccount"
export const pathProfile: string = pathPrefix + "/profile"

export const pathNewsSubAll: string = pathNews + "/all"
export const pathNewsSubPinned: string = pathNews + "/pinned"
export const pathNewsSubImportant: string = pathNews + "/important"

// export const setShowDemandRate = createEvent<boolean>(); НЕ ИСПОЛЬЗУЕТСЯ
// export const $showDemandRate = restore<boolean>(setShowDemandRate, true);

export const setAppIOSLink = createEvent<string>();
export const $appIOSLink = restore<string>(setAppIOSLink, "");

export const setAppAndroidLink = createEvent<string>();
export const $appAndroidLink = restore<string>(setAppAndroidLink, "");

export const setUserAgreementLink = createEvent<string>();
export const $userAgreementLink = restore<string>(setUserAgreementLink, "");

export const setAboutDeveloperLink = createEvent<string>();
export const $aboutDeveloperLink = restore<string>(setAboutDeveloperLink, "https://kras-abs.ru/");

export const API_ACCESS_KEY1 = "2ec24ebc-3015-427b-bb88-88d5ba43280b"



//export const setHideActivities = createEvent<string[]>();
//export const $hiddenActivities = restore<string[]>(setHideActivities, "");



